import pagamentoProcesso from "../_services/PagamentoProcesso";
import { erroArrayToString } from "@/utils/trataErroRetornoApi";
import { PagamentoProcessoModel } from "./../_model/index";
import { reject } from "lodash";

const state = {
  loading: false,
  loadingStore: false,
  pagamentoProcesso: [],
  pagamentoProcessoSelecionado: undefined,
  erros: "",
};

const getters = {
  GET_PGTOPROCESSO: (state) => state.pagamentoProcesso,
  GET_ERROS: (state) => state.erros,
};

const mutations = {
  SET_LOADING_STORE: (state, ativo) => {
    state.loadingStore = ativo ? ativo : false;
  },

  PGTOPROCESSO_SELECTED: (state, { pagamento_processo }) => {
    state.pagamentoProcessoSelecionado = Object.assign({}, pagamento_processo);
  },

  SET_PGTOPROCESSO: (state, { pagamento_processo }) => {
    state.pagamentoProcesso = pagamento_processo;
  },

  SET_ERROS: (state, erros) => {
    state.erros = erros.erros;
  },

  ERASE_ERROS: (state) => {
    state.erros = "";
  },

  RESET_SELECTED: (state) => (state.pagamentoProcessoSelecionado = undefined),
};

const actions = {
  /*GET_PGTOPROCESSOS : async ({ commit }) => {
      commit('SET_PGTOPROCESSO', { pagamento_processo : []})
      commit('ERASE_ERROS')
      await pagamentoProcesso.getPagamentoProcessos()
      .then(response => {
        if (response.data.status) {
          commit('SET_PGTOPROCESSO', { pagamento_processo : response.data.pagamento_processo })
        } else if (response.data.erro) {
          commit('SET_ERROS', { erros: response.data.erro })
        }
      })
      .catch(error => {
        console.log(error)
        commit('SET_ERROS', { erros: 'Erro ao acessar api' })
        reject(error)
      })
  },*/

  GET_PGTOPROCESSO: async ({ commit, dispatch }, id) => {
    return new Promise(async (resolve, reject) => {
      commit("ERASE_ERROS");
      pagamentoProcesso
        .getPagamentoProcesso(id)
        .then((response) => {
          if (response.data.status) {
            let pgtoprocesso = response.data.pagamento_processo;
            if (pgtoprocesso) {
              commit("PGTOPROCESSO_SELECTED", {
                pagamento_processo: response.data.pagamento_processo,
              });
            } else {
              dispatch("PGTOPROCESSO_SELECTED", null);
            }
            resolve(response.data);
          } else if (response.data.erro) {
            commit("SET_ERROS", { erros: response.data.erro });
            reject(response.data.erro);
          }
        })
        .catch((error) => {
          console.log(error);
          commit("SET_ERROS", { erros: "Erro ao acessar api" });
          reject(error);
        });
    });
  },

  STORE_PGTOPROCESSO: ({ commit, dispatch }, pagamento_processo) => {
    return new Promise(async (resolve, reject) => {
      commit("ERASE_ERROS");
      try {
        commit("SET_LOADING_STORE", true);
        var response = await pagamentoProcesso.postPagamentoProcesso(
          pagamento_processo
        );

        if (response.data.status) {
          commit("PGTOPROCESSO_SELECTED", {
            pagamento_processo: response.data.pagamento_processo,
          });
          //dispatch('GET_PGTOPROCESSO', processo_id)
          resolve();
        } else if (!response.data.status && response.data.validacao) {
          var erros = erroArrayToString(response.data.erros);
          commit("processo/SET_ERROS", { erros: erros }, { root: true });
          reject(erros);
        } else if (response.data.erro) {
          commit(
            "processo/SET_ERROS",
            { erros: response.data.erro },
            { root: true }
          );
          reject(response.data.erro);
        }
      } catch (error) {
        console.log(error);
        commit("SET_ERROS", { erros: "Erro ao acessar api" });
        reject(error);
      } finally {
        commit("SET_LOADING_STORE", false);
      }
    });
  },

  DELETE_PGTOPROCESSO: async ({ commit, dispatch }, pagtoProcesso) => {
    commit("ERASE_ERROS");
    try {
      var response = await pagamentoProcesso.deletePagamentoProcesso(
        pagtoProcesso.id
      );

      if (response.data.status) {
        await dispatch("GET_PGTOPROCESSO");
      } else if (response.data.erro) {
        commit("SET_ERROS", { erros: response.data.erro });
      }
    } catch (error) {
      console.log(error);
      commit("SET_ERROS", { erros: "Erro ao acessar api" });
      reject(error);
    }
  },

  PGTOPROCESSO_SELECTED: async ({ dispatch, commit }, id) => {
    if (id > 0) {
      await dispatch("GET_PGTOPROCESSO", id);
    } else {
      var obj = new PagamentoProcessoModel.pagamento_processo();
      await commit("PGTOPROCESSO_SELECTED", { pagamento_processo: obj });
    }
  },

  RESET_SELECTED: ({ commit }) => {
    commit("RESET_SELECTED");
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/views/Pagamentos/_store/index.js